export default __webpack_public_path__ + "v3.418/youtube-logo.png";